import Cards from "./Cards";

export default function Main() {
    return (
        <div className='main'>
           <Cards />
        </div>
    )
}